import React, { useState, useEffect } from "react";
import itemMap from "../utils/itemMap";
import MaterialPickerModal from "./MaterialPickerModal";
import {
  trays, chairs, neons, sunumluklar, columns,
  sehpalar, mumluklar, shamdanlar, benchler,
  vazolar, pastastandlari, Halılar, Işıklar
} from "../data/itemsList";

const categories = {
  Tepsiler: trays,
  Sandalyeler: chairs,
  Neonlar: neons,
  Sunumluklar: sunumluklar,
  Sütunlar: columns,
  Sehpalar: sehpalar,
  Mumluklar: mumluklar,
  Şamdanlar: shamdanlar,
  Benchler: benchler,
  Vazolar: vazolar,
  "Pasta Standları": pastastandlari,
  Halılar: Halılar,
  Işıklar: Işıklar
};

function MaterialListModal({ isOpen, onClose, defaultItems, onConfirm }) {
  const [items, setItems] = useState([]);
  const [showPicker, setShowPicker] = useState({ open: false, items: null });

  useEffect(() => {
    if (isOpen && defaultItems) {
      setItems(defaultItems);
    }
  }, [isOpen, defaultItems]);

  const handleToggle = (index) => {
    setItems((prev) =>
      prev.map((it, i) =>
        i === index ? { ...it, checked: !it.checked } : it
      )
    );
  };

  const handleDelete = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const handleConfirm = () => {
    onConfirm(items);
  };

  const handleChange = (index) => {
    const currentName = items[index].name;

    const matchedCategory = Object.entries(categories).find(([, list]) =>
      list.some((it) => it.name === currentName)
    );

    const categoryItems = matchedCategory ? matchedCategory[1] : [];

    setShowPicker({
      open: true,
      items: categoryItems,
      changeIndex: index,
    });
  };

  const handleAddItem = (item) => {
    if (showPicker.changeIndex !== undefined) {
      // Değiştir modunda
      setItems((prev) =>
        prev.map((it, i) =>
          i === showPicker.changeIndex ? { ...item, checked: true } : it
        )
      );
    } else {
      // Yeni ekleme
      setItems((prev) => [...prev, { ...item, checked: true }]);
    }

    setShowPicker({ open: false, items: null });
  };

  if (!isOpen) return null;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <h3 style={styles.title}>Malzeme Seçimi</h3>

        <div style={styles.grid}>
          {items.map((item, i) => (
            <div
              key={i}
              style={{
                ...styles.card,
                borderColor: item.checked ? "#10b981" : "#d1d5db",
                backgroundColor: item.checked ? "#ecfdf5" : "#fff",
              }}
              onClick={() => handleToggle(i)}
            >
              <img
                src={itemMap[item.name] || "/placeholder.png"}
                alt={item.name}
                style={styles.image}
              />
              <p style={styles.itemName}>{item.name}</p>
              <button
                style={styles.deleteButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(i);
                }}
              >
                Sil
              </button>
              <button
                style={styles.changeButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleChange(i);
                }}
              >
                Değiştir
              </button>
            </div>
          ))}
        </div>

        <button
          style={styles.addButton}
          onClick={() => setShowPicker({ open: true, items: null })}
        >
          Malzeme Ekle
        </button>

        <div style={styles.actions}>
          <button style={styles.confirmButton} onClick={handleConfirm}>
            Onayla
          </button>
          <button style={styles.cancelButton} onClick={onClose}>
            İptal
          </button>
        </div>
      </div>

      <MaterialPickerModal
        isOpen={showPicker.open}
        onClose={() => setShowPicker({ open: false, items: null })}
        onSelect={handleAddItem}
        items={showPicker.items}
      />
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff",
    borderRadius: "10px",
    padding: "20px",
    width: "95%",
    maxWidth: "800px",
    maxHeight: "90vh",
    overflowY: "auto",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    fontFamily: "'Segoe UI', sans-serif",
  },
  title: {
    fontSize: "20px",
    marginBottom: "16px",
    color: "#374151",
    textAlign: "center",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  card: {
    border: "2px solid #d1d5db",
    borderRadius: "8px",
    padding: "10px",
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    position: "relative",
  },
  image: {
    width: "100%",
    height: "90px",
    objectFit: "cover",
    borderRadius: "6px",
    marginBottom: "6px",
  },
  itemName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#111827",
  },
  deleteButton: {
    position: "absolute",
    top: "6px",
    right: "6px",
    background: "#ef4444",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "12px",
    cursor: "pointer",
  },
  changeButton: {
    position: "absolute",
    bottom: "6px",
    right: "6px",
    background: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "2px 6px",
    fontSize: "12px",
    cursor: "pointer",
  },
  addButton: {
    background: "#3b82f6",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "4px",
    border: "none",
    cursor: "pointer",
    marginBottom: "16px",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
  },
  confirmButton: {
    background: "#10b981",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },
  cancelButton: {
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },
};

export default MaterialListModal;
